import { useState, useContext, useEffect } from "react";
import "./header.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../Contexts/AuthContext";
import { CgProfile } from "react-icons/cg";
import { AiTwotoneDashboard } from "react-icons/ai";
import { PiCowFill } from "react-icons/pi";
import { IoIosAddCircleOutline } from "react-icons/io";
import { LuListTodo } from "react-icons/lu";
import { FaUsersCog, FaShieldAlt } from "react-icons/fa";
import milkLogo from "../../screenshots/Milkfarm.jpeg";
import { useTranslation } from "react-i18next";

export default function Header() {
  const { user, logout } = useContext(AuthContext);
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const currentLanguage = ["en", "fr", "ar"].includes(i18n.resolvedLanguage)
    ? i18n.resolvedLanguage
    : "en";

  const handleLanguageChange = (event) => {
    const language = event.target.value;
    i18n.changeLanguage(language);
    localStorage.setItem("lang", language);
  };
  

    useEffect(() => {
      const onScroll = () => setScrolled(window.scrollY > 60);
      window.addEventListener("scroll", onScroll, { passive: true });
      return () => window.removeEventListener("scroll", onScroll);
    }, []);
  const handleLogout = () => {
    logout();
    setOpen(false);
    navigate("/");
  };

  const onClickLink = () => {
    setTimeout(() => setOpen(false), 300);
  };

  const isActive = (path) => location.pathname === path;

  const languageSelect = (
    <select
      className="logout"
      value={currentLanguage}
      onChange={handleLanguageChange}
      aria-label={t("header.language")}
    >
      <option value="en">EN</option>
      <option value="fr">FR</option>
      <option value="ar">AR</option>
    </select>
  );

  const superAdminMenu = (
    <>
      <Link className={isActive("/superadmin") ? "active" : ""} onClick={onClickLink} to="/superadmin"><FaShieldAlt /> {t("header.superAdmin")}</Link>
    </>
  );

  const adminMenu = (
    <>
      <Link className={isActive("/admin/profile") ? "active" : ""} onClick={onClickLink} to="/admin/profile"><CgProfile /> {t("header.profile")}</Link>
      <Link className={isActive("/") ? "active" : ""} onClick={onClickLink} to="/">{t("header.home")}</Link>
      <Link className={isActive("/admin") ? "active" : ""} onClick={onClickLink} to="/admin"><AiTwotoneDashboard /> {t("header.dashboard")}</Link>
      <Link className={isActive("/admin/animals") ? "active" : ""} onClick={onClickLink} to="/admin/animals"><PiCowFill /> {t("header.animals")}</Link>
      <Link className={isActive("/admin/to-do") ? "active" : ""} onClick={onClickLink} to="/admin/to-do"><LuListTodo /> {t("header.todo")}</Link>
      <Link className={isActive("/admin/manage-users") ? "active" : ""} onClick={onClickLink} to="/admin/manage-users"><FaUsersCog /> {t("header.manageUsers")}</Link>
      <Link className={isActive("/admin/reproduction") ? "active" : ""} onClick={onClickLink} to="/admin/reproduction">{t("header.reproduction")}</Link>
      <Link className={isActive("/admin/croissance") ? "active" : ""} onClick={onClickLink} to="/admin/croissance">{t("header.growth")}</Link>
    </>
  );

  const eleveurMenu = (
    <>
      <Link className={isActive("/eleveur/profile") ? "active" : ""} onClick={onClickLink} to="/eleveur/profile"><CgProfile /> {t("header.profile")}</Link>
      <Link className={isActive("/eleveur") ? "active" : ""} onClick={onClickLink} to="/eleveur"><AiTwotoneDashboard /> {t("header.dashboard")}</Link>
      <Link className={isActive("/eleveur/animals") ? "active" : ""} onClick={onClickLink} to="/eleveur/animals"><PiCowFill /> {t("header.animals")}</Link>
      <Link className={isActive("/eleveur/to-do") ? "active" : ""} onClick={onClickLink} to="/eleveur/to-do"><LuListTodo /> {t("header.todo")}</Link>
      <Link className={isActive("/eleveur/reproduction") ? "active" : ""} onClick={onClickLink} to="/eleveur/reproduction">{t("header.reproduction")}</Link>
      <Link className={isActive("/eleveur/croissance") ? "active" : ""} onClick={onClickLink} to="/eleveur/croissance">{t("header.growth")}</Link>
    </>
  );

  const navLanding = (
    <>
      <a href="#features">{t("header.features")}</a>
      <a href="#how-it-works">{t("header.howItWorks")}</a>
      <a href="#benefits">{t("header.advantages")}</a>
      <a href="#pricing">{t("header.pricing")}</a>
      {!user ? ( <><button className="nav-btn login-btn" onClick={() => navigate("/signin")}>{t("header.login")}</button>
      <button className="nav-btn signup-btn" onClick={() => navigate("/signup")}>{t("header.getStarted")}</button></>) :
        <button className="nav-btn signup-btn" onClick={() => navigate("/"+user?.role)}>{t("header.dashboard")}</button>
      }
    </>
  );

  return (
    <header className={`header${scrolled ? " scrolled" : ""}`}>
      <div className="logo">
        <Link to="/">
          <img src={milkLogo} className="logo-milk-farm" alt="Milk Farm" />
        </Link>
      </div>

      <nav className="nav">
        {languageSelect}
        {isActive("/") && navLanding}
        {(user?.role === "superadmin" && !isActive("/")) && superAdminMenu}
        {(user?.role === "admin" && !isActive("/")) && adminMenu}
        {(user?.role === "eleveur" && !isActive("/")) && eleveurMenu}

        {user && <button onClick={handleLogout} className="logout">{t("header.logout")}</button>}
      </nav>

      <button className="menu-btn" onClick={() => setOpen(!open)}>
        &#9776;
      </button>

      {open && (
        <div className="mobile-menu">
          {languageSelect}
          {isActive("/") && navLanding}
          {(user?.role === "superadmin" && !isActive("/")) && superAdminMenu}
          {(user?.role === "admin" && !isActive("/")) && adminMenu}
          {(user?.role === "eleveur" && !isActive("/")) && eleveurMenu}

          {(user && !isActive("/")) && <button onClick={handleLogout} className="logout">{t("header.logout")}</button>}
        </div>
      )}
    </header>
  );
}

